// Imports

import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { sq_personalise } from 'src/lib/personalisation.js';
import { isDevelopment} from "src/lib/utils";
import { MyGrades } from "src/modules/my-grades/jsx/component.jsx";
import { ExamTimetable } from "src/modules/exam-timetable/jsx/component.jsx";



// Stateful components
export class Tiles extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            "tiles": null
        };

        // Binds
        this.processTiles = this.processTiles.bind(this);
        this.getCurrentPageTiles = this.getCurrentPageTiles.bind(this);
        this.compareTiles = this.compareTiles.bind(this);
        this.writeTilesToGatekeeper = this.writeTilesToGatekeeper.bind(this);
        this.showGradesModal = this.showGradesModal.bind(this);
        this.showExamModal = this.showExamModal.bind(this);
        this.handleTimetablePrint = this.handleTimetablePrint.bind(this);
    }

    componentDidMount(){
        var this_component = this;
        var tiles = this_component.getCurrentPageTiles();

        var processed_tiles = this_component.processTiles(tiles);

        this_component.setState({
            "tiles": processed_tiles
        });
    }

    //
    // Events
    //

    showGradesModal(e) {
        e.preventDefault();

        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        var modal_content = <MyGrades />;
        var modal_buttons = [{
            'class': 'btn btn-secondary',
            'label': 'Close',
            'clickHandler': null,
            'action': 'close'
        }];

        // Get modal data
        var modal_data = {
            'title': 'My grades',
            'class': 'modal-results',
            'content': modal_content,
            'buttons': modal_buttons
        };

        // Set modal content and display
        helpers.setModalContent(modal_data);
    }

    showExamModal(e) {
        e.preventDefault();

        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        var modal_content = <ExamTimetable />;
        var modal_buttons = [
            {
                'class': 'btn btn-primary',
                'label': 'Print / Download PDF',
                'clickHandler': this.handleTimetablePrint,
                'action': 'custom'
            },
            {
                'class': 'btn btn-secondary',
                'label': 'Close',
                'clickHandler': null,
                'action': 'close'
            }
        ];

        // Get modal data
        var modal_data = {
            'title': 'Exam Timetable',
            'class': 'modal-exams',
            'content': modal_content,
            'buttons': modal_buttons
        };

        // Set modal content and display
        helpers.setModalContent(modal_data);
    }

    handleTimetablePrint(event) {

        // Add element if it's not already there
        if ( document.querySelector('.printable-content') === null ) {
            var new_child = document.createElement("div");
            new_child.classList.add('printable-content');
            document.querySelector('.page-wrapper').appendChild(new_child);
        }

        // Clear it
        var print_area = document.querySelector('.printable-content');
        while (print_area.firstChild){
            print_area.removeChild(print_area.firstChild);
        }

        var content = document.querySelector('.modal__section').innerHTML;
        document.querySelector('.printable-content').innerHTML = '<h1>Exam Timetable</h1>' + content;

        window.print();
    }

    //
    // Functions
    //
    getCurrentPageTiles(){
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        var current_page = portal_context['current_page'];
        
        if (current_page) {
            if (current_page == 'home'){
                current_page = '';
            }
     
            var page_data = helpers.getPageBySlug(current_page);
    
            if(typeof page_data['content'] != 'undefined' && typeof page_data['content']['tiles'] != 'undefined'){
                return page_data['content']['tiles'];
            }
        }

        return null;
    }

    compareTiles(current_tiles, stored_tiles){
        for(var index = 0; index < current_tiles.length; index++){
            // check if the id is not in storage already
            if(stored_tiles.indexOf(current_tiles[index]['id']) == -1){
                // if it's not, its a 'new' item
                current_tiles[index]['new'] = true;
            } else {
                current_tiles[index]['new'] = false;
            }
        }

        return current_tiles;
    }

    writeTilesToGatekeeper(tiles, tile_storage){
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var tile_ids = tiles.map(function(tile) {
            return tile.id;
        });

        // Merge tiles with existing in storage
        var all_ids = tile_storage.concat(tile_ids);

        // Remove duplicate ids
        var gatekeeper_ids = all_ids.filter(function(value, index, self) {
            return self.indexOf(value) === index;
        });

        if (gatekeeper_ids.length !== tile_storage.length) {
            var gatekeeper_options = {
                "source": "setallstorage,1",
                "data": gatekeeper_ids,
                "success": function(response){
                    
                },
                "startsWithParam": "tiles"
            };
            
            //
            // place to write back to gatekeeper API
            //
            helpers.setGatekeeperData(gatekeeper_options);
        }
    }

    processTiles(page_tiles){
        var this_component = this;
        var portal_context = this_component['context'];
        var user_personalisation = portal_context['user_personalisation'];
       
        if(page_tiles){
            var min_tile_count = page_tiles['min_count'];
            var filtered_tiles = [];

            // Get personalised results
            filtered_tiles = sq_personalise.fn.filterItems(page_tiles['tile_list'], user_personalisation['attributes']);
        

            // if less than the max limit, go grab some backup tiles
            if(filtered_tiles.length < min_tile_count){
                var current_count = filtered_tiles.length;
                var backup_tiles_needed = min_tile_count - current_count;
                var backup_tiles = sq_personalise.fn.filterItems(page_tiles['placeholder_list'], user_personalisation['attributes']);

                if(backup_tiles.length > backup_tiles_needed){
                    backup_tiles = backup_tiles.slice(0,backup_tiles_needed);
                }
                
                filtered_tiles = filtered_tiles.concat(backup_tiles);
            }
            
            var all_storage = squiz.fn.getStorage('getallstorage', 'session', 'json');
            var tile_storage = [];
    
            if(all_storage !== null) {
                // if tiles are in storage, compare them
                if (typeof all_storage['data']['tiles'] != 'undefined' && all_storage['data']['tiles'].length > 0){
                    tile_storage = all_storage['data']['tiles'];
                }
            }
            
            // compare tiles
            var compared_tiles = filtered_tiles;
            compared_tiles = this_component.compareTiles(filtered_tiles, tile_storage);
            
            if(compared_tiles.length !== tile_storage.length){
                this_component.writeTilesToGatekeeper(compared_tiles, tile_storage);
            }

            return compared_tiles;
        }

        return null;
    }

    getProgress(term, data) {
        var this_component = this;
        var portal_context = this_component['context'];
        var user_personalisation = portal_context['user_personalisation'];
        var user_term = null;
        var default_progress = {
            'style': 0,
            'label': 0
        };

        if (typeof(user_personalisation) !== 'undefined') {
            if (user_personalisation['attributes'] !== undefined ) {
                user_term = user_personalisation['attributes'][term]
            }
        }

        if (isDevelopment()) {
            user_term = "3181";
        }

        //filter out the programs where the admitTerm != user_term
        var filtered_programs = [];
        var my_courses = squiz.fn.getStorage('getmycourses', 'session', 'json');
        
        if (typeof(my_courses) !== 'undefined') {

            if (my_courses['data']['programs'] !== undefined) {
                
                var programs = my_courses['data']['programs'];

                for (var i = 0; i < programs.length; i++){
                    var program = programs[i];
                    var admit_term = program['admitTerm'];
                    var program_code = program['code']; 

                    //if the programs admit term is the same as the users term
                    if(admit_term === user_term){
                        filtered_programs.push(program_code);
                    }
                }
            }
        }

        //determine whether to show the percentage that is being passed through
        // or to reset it to 0 %
        var show_current_percentage = false;
        var progress_obj = squiz.fn.getStorage(data, 'session', 'json');

        if (progress_obj !== null) {
            
            if (progress_obj['data']['admitTerm'] !== undefined && progress_obj['data']['programCode'] !== undefined ) {
                
                var admit_term = progress_obj['data']['admitTerm'];

                //if the programs admit term is the same as the users term
                if (admit_term === user_term){
                    
                    //get the program codes from the percentage api
                    var progress_program_codes = progress_obj['data']['programCode'];
                    var percent_val = progress_obj['data']['percentageComplete'];

                    // determine whether a new program code exists in the users program codes
                    var new_program = false;
                    for (var i = 0; i < filtered_programs.length; i++){
                        if (progress_program_codes.indexOf(filtered_programs[i]) === -1) {
                            new_program = true;
                        }
                    }

                    //only show current percentage if there isnt a new program;
                    show_current_percentage = !new_program;

                    //show the current percentage or show 0%
                    if (show_current_percentage === true && percent_val !== undefined){
                        var percentage = Math.floor(percent_val);

                        // If percentange is not valid
                        if ( percentage < 0 || percentage > 100 ) {
                            return default_progress;
                        }
                        // Make the circle full at 100%
                        var css_percentage = (percentage === 100 ? 101 : percentage);
                        var user_progress = {
                            'style': css_percentage,
                            'label': percentage
                        }

                        return user_progress;
                    }
                }
            }
        }

        return default_progress;
    }

    checkForDynamicLinks(tile) {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var cta_1_target = tile['cta_1_target'];
        var cta_2_target = tile['cta_2_target'];

        if(typeof(cta_1_target) !== 'undefined') {
            if(typeof(tile['cta_1_target_link_id']) !== 'undefined') {
                tile['cta_1_target'] = helpers.getDynamicLinkUrlById(tile['cta_1_target_link_id']);
            } else {
                tile['cta_1_target'] = helpers.getDynamicLinkURL(cta_1_target);
            }
        }

        if(typeof(cta_2_target) !== 'undefined') {
            
            if(typeof(tile['cta_2_target_link_id']) !== 'undefined') {
                tile['cta_2_target'] = helpers.getDynamicLinkUrlById(tile['cta_2_target_link_id']);
            } else {
                tile['cta_2_target'] = helpers.getDynamicLinkURL(cta_2_target);
            }
        }

        return tile;
    }


    //
    // Render
    //

    renderProgressWheel(percentage) {
        var counter_wrapper_class = 'pie-chart__counter';
        var fill_style = {
            "strokeDasharray": percentage['style'] + " 100"
        };
        
        // Adjust the styling to fit triple digits
        if(percentage['style'] >= 100) {
            counter_wrapper_class += ' pie-chart__counter--max';
        }

        return (
            <div className="content-tile__progress">
                <div className="pie-chart">
                    <svg className="pie-chart__svg" viewBox="0 0 32 32">
                        <circle className="pie-chart__bg-medium" r="13.5" cx="16" cy="16" />
                        <circle className="pie-chart__bg-small " r="8.5" cx="16" cy="16" />
                        <circle className="pie-chart__fill pie-chart__fill-large" r="16" cx="16" cy="16" style={fill_style} />
                        <circle className="pie-chart__fill pie-chart__fill-medium" r="16" cx="16" cy="16" style={fill_style} />
                        <circle className="pie-chart__fill pie-chart__fill-small" r="16" cx="16" cy="16" style={fill_style} />
                    </svg>
                    <div className={counter_wrapper_class}>
                        <span className="pie-chart__count">{percentage['label']}</span>
                        <span>%</span>
                    </div>
                    <div className="pie-chart__complete-text">
                        <span>complete</span>
                    </div>
                </div>
            </div>
        );
    }

    // Generates HTML for each tile in array
    formatTiles(tiles) {
        var this_component = this;
        var portal_context = this_component['context'];
        var user_personalisation = portal_context['user_personalisation'];
        var user_attributes = user_personalisation['attributes'];

        if (tiles) {
            return tiles.map(function(tile){
                // Look for links in the links libary
                tile = this_component.checkForDynamicLinks(tile);
    
                // Personalise content
                var personalised_title = sq_personalise.fn.renderUserAttributes(tile['name'], user_attributes);
                var personalised_content = sq_personalise.fn.renderUserAttributes(tile['content'], user_attributes);
    
                var content = {
                    '__html': personalised_content
                };
                var tile_classes = (tile['new'] ? 'content-tile content-tile--new' : 'content-tile');
                
                var tile_type = tile['type'] ? tile['type'] : null;
                if (tile_type !== null) {
                    tile_classes += ' content-tile--' + tile_type;
                }
    
                var tile_progress = null; //Only show progress wheel if orientation/globaljourney tile
                var modal_btn = null; //Only show for grades tile
                
                // Custom tiles
                switch (tile_type) {
                    
                    case 'orientation':
                        var percentage = this_component.getProgress('ORIENTATION_TERM', 'getmytaskspercent');
                        tile_progress = this_component.renderProgressWheel(percentage);
                        content = {
                            '__html': "You've completed <span class=\"content-tile__percent\">" + percentage['label'] + "<\/span>%"
                        };
                        break;
                    
                    case 'globaljourney':
                        var percentage = this_component.getProgress('OPD_START_TERM', 'getjourneypercent');
                        tile_progress = this_component.renderProgressWheel(percentage);
                        content = {
                            '__html': "You've completed <span class=\"content-tile__percent\">" + percentage['label'] + "<\/span>%"
                        };
                        break;
                    
                    case 'grades':
                        modal_btn = (
                            <a href="#" className="content-tile__link" onClick={this_component.showGradesModal}>
                                View grades
                            </a>
                        );
                        break;

                    case 'exams':
                        modal_btn = (
                            <a href="#" className="content-tile__link" onClick={this_component.showExamModal}>
                                View exams
                            </a>
                        );
                        break;
                }

                // Tile markup
                return (
                    <div className={tile_classes} key={tile.id}>
                        <h3 className="content-tile__title">
                            {personalised_title}
                        </h3>
                        {tile_progress}
                        <div className="content-tile__content" dangerouslySetInnerHTML={content}></div>
                        {modal_btn}
                        {tile.cta_1_name.length > 0 &&
                            <a href={tile.cta_1_target} className="content-tile__link">
                                {tile.cta_1_name}
                            </a>
                        }
                        {tile.cta_2_name.length > 0 &&
                            <a href={tile.cta_2_target} className="content-tile__link--button">
                                {tile.cta_2_name}
                            </a>
                        }
                    </div>
                );
            });
        }
        return null;
    }

    // Renders overall tile component with wrapper
    renderTiles(tiles) {
        var this_component = this;
        var processed_tiles = this_component['state']['tiles'];
        var no_of_columns = this_component['props']['columns'] ? this_component['props']['columns'] : 'two';
        
        var tile_background = this_component['props']['background'] === 'dark' ? ' content-tiles__wrapper--dark-bg' : '';
        
            if (processed_tiles) {
                
                // Mixed column layout for support page
                if (no_of_columns === 'mixed') {

                    var ROWS_WITH_TWO_COLS = 2;

                    if (processed_tiles.length <= (ROWS_WITH_TWO_COLS * 2)) {
                        return (
                            <div className={"content-tiles__wrapper content-tiles__wrapper--two-col" + tile_background} data-ga-label="Tiles">
                                {this_component.formatTiles(processed_tiles)}
                            </div>
                        );
                    } else {
                        var tile_group_1 = processed_tiles.slice(0, ROWS_WITH_TWO_COLS * 2);
                        var tile_group_2 = processed_tiles.slice(ROWS_WITH_TWO_COLS * 2);

                        return (
                            <>
                                <div className={"content-tiles__wrapper content-tiles__wrapper--two-col" + tile_background} data-ga-label="Tiles">
                                    {this_component.formatTiles(tile_group_1)}
                                </div>
                                <div className={"content-tiles__wrapper content-tiles__wrapper--three-col" + tile_background} data-ga-label="Tiles">
                                    {this_component.formatTiles(tile_group_2)}
                                </div>
                            </>
                        );
                    }

                // Fixed column layout (based on prop)
                } else {

                    // Render
                    return (
                        <div className={"content-tiles__wrapper content-tiles__wrapper--" + no_of_columns + "-col" + tile_background} data-ga-label="Tiles">
                            {this_component.formatTiles(processed_tiles)}
                        </div>
                    );
                }

                
            }

        
    }

    render() {
        var this_component = this;
        var tiles = this_component.renderTiles();

        return (
            <>
                {tiles}
            </>
        );
    }

};

Tiles.contextType = PortalContext;
